import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getLanguageCode } from "../utils/languageUtility";

const DASHBOARD_LANGUAGES = ["en", "fr"];

export const isDashboardLanguage = (language: string | undefined): boolean =>
  DASHBOARD_LANGUAGES.includes(getLanguageCode(language || ""));

/** The dashboard is only translated into English and French: any other language would leave its amounts and dates in that language under English text. */
export const useDashboardLanguage = () => {
  const { i18n } = useTranslation();
  // On mount only: the previews of client pages in the dashboard have a language selector that must keep working.
  useEffect(() => {
    if (!isDashboardLanguage(i18n.language)) {
      void i18n.changeLanguage("en");
    }
  }, [i18n]);
};
